import { BaseFormatAdapter } from 'app/model/adapters/dataflow/formatAdapters/base-format.adapter';
import { DataFlowDSLAdapterRegistry, Metamodel, Owned } from 'shell-models-lib';
import { DataFlowSource } from 'app/model/dataflow/dataflow-source';
import { DataFlowSink } from 'app/model/dataflow/dataflow-sink';
import { DatasetFormatType } from 'app/model/dataflow/dataset-settings/dataflow-dataset-settings';
import { SalesforceSettings } from 'app/model/dataflow/dataset-settings/salesforce-settings';
import { DataFlowExpressionUtils } from '../expression.util';
import { IntegerDataFlowType, StringDataFlowType } from 'app/model/dataflow/dataflow-datatype';

@DataFlowDSLAdapterRegistry.adapter({
    model: Metamodel.modelFor(SalesforceSettings)
})
export class SalesforceAdapter extends BaseFormatAdapter<SalesforceSettings> {
    public async toSourceDSL(setting: SalesforceSettings): Promise<string[]> {
        const props = [];
        props.push(`store: '${DatasetFormatType.Salesforce}'`);
        if (setting.objectApiName.expression) {
            props.push(
                `objectApiName: ${DataFlowExpressionUtils.wrapExpressionConfigValue(
                    setting.objectApiName,
                    StringDataFlowType.TYPE
                )}`
            );
        }
        if (setting.maxRecords.expression) {
            props.push(
                `maxRecords: ${DataFlowExpressionUtils.wrapExpressionConfigValue(
                    setting.maxRecords,
                    IntegerDataFlowType.TYPE
                )}`
            );
        }
        return props;
    }

    public async toSourceModel(
        owner: DataFlowSource,
        configs: Map<string, string>,
        handledConfigs: string[]
    ): Promise<SalesforceSettings> {
        const setting = this._generateSetting(owner);
        if (configs.has('objectApiName')) {
            setting.objectApiName = DataFlowExpressionUtils.unwrapExpressionConfigValue(
                configs.get('objectApiName'),
                owner,
                StringDataFlowType.TYPE
            );
            handledConfigs.push('objectApiName');
        }
        if (configs.has('maxRecords')) {
            setting.maxRecords = DataFlowExpressionUtils.unwrapExpressionConfigValue(
                configs.get('maxRecords'),
                owner,
                IntegerDataFlowType.TYPE
            );
            handledConfigs.push('maxRecords');
        }
        return setting;
    }

    protected _generateSetting(owner: DataFlowSource | DataFlowSink): SalesforceSettings {
        const setting = Owned.create<SalesforceSettings>(SalesforceSettings.MODEL, owner);
        setting.initialize(undefined);
        return setting;
    }
}
